import styled from "styled-components";

const InnerContainer = styled.div`
  @media (max-width: 575px) {
    margin-top: 25px;
  }
`;
export default InnerContainer;
